var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 5.41667C2.5 3.22899 2.52342 2.5 5.41667 2.5C8.30991 2.5 8.33333 3.22899 8.33333 5.41667C8.33333 7.60434 8.34256 8.33333 5.41667 8.33333C2.49077 8.33333 2.5 7.60434 2.5 5.41667Z",
    stroke: "#181D27",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6667 5.41667C11.6667 3.22899 11.6901 2.5 14.5833 2.5C17.4766 2.5 17.5 3.22899 17.5 5.41667C17.5 7.60434 17.5092 8.33333 14.5833 8.33333C11.6574 8.33333 11.6667 7.60434 11.6667 5.41667Z",
    stroke: "#181D27",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 14.5833C2.5 12.3956 2.52342 11.6667 5.41667 11.6667C8.30991 11.6667 8.33333 12.3956 8.33333 14.5833C8.33333 16.771 8.34256 17.5 5.41667 17.5C2.49077 17.5 2.5 16.771 2.5 14.5833Z",
    stroke: "#181D27",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6667 14.5833C11.6667 12.3956 11.6901 11.6667 14.5833 11.6667C17.4766 11.6667 17.5 12.3956 17.5 14.5833C17.5 16.771 17.5092 17.5 14.5833 17.5C11.6574 17.5 11.6667 16.771 11.6667 14.5833Z",
    stroke: "#181D27",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.07f2ff3ad354d2f03e20f74eaa90e10b.svg";
export { ForwardRef as ReactComponent };